import styled from "@emotion/styled";
import { styled as muiStyled } from "@mui/material";
import { ReactComponent as CloseIconSvg } from "../assets/PopupCloseIcon.svg";

export const HeaderContainer = styled.div`
  align-items: center;
  color: #14274e;
  display: flex;
  justify-content: space-between;
`;

export const ActionsContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  height: 100%;
  margin-top: 5px;
  width: 100%;
`;

export const PopupCloseIconComponent = () => {
  return <CloseIconSvg style={{ height: 24, width: 24, fill: "#14274E" }} />;
};

export const DefaultChoicesContainer = muiStyled("div")<{
  containerHeight?: String;
}>((theme: any) => ({
  height: theme.containerHeight,
  padding: "10px",
  display: "flex",
  alignItems: "center",
  backgroundColor: "#eae6ff",
  textAlign: "initial"
}));

export const DefaultChoicesImageContainer = muiStyled("div")({
  width: "50px",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

export const DefaultChoicesTextContainer = muiStyled("div")({
  width: "calc(100% - 50px)",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "14px",
  fontFamily: "Poppins",
});
